<template>
	<div v-if="bannerData" class="w-full !py-2 bg-black flex justify-center items-center">
		<p class="!m-0 !p-0 w-fit text-xs/[18px] max-w-[390px] md:max-w-none font-normal text-white text-center">
			<span class="pe-2">{{ message }}</span>
			<hero-banner-modal
				ref="heroModal"
				v-if="hasModal && id === 'reunion_2025'"
				:auto-show="autoShow"
				:id="id"
				btn-class="text-white text-xs/[18px] underline underline-offset-2"
				:show-btn="true"
				:btn-text="cta"
			>
				<template v-slot:content-left>
					<div class="flex flex-col gap-4 justify-center h-full md:max-h-[360px] !py-4.5">
						<h3 class="text-center !m-0 !p-0 font-butler-light text-4xl font-light uppercase">MEET THE NEW ARRIVALS</h3>
						<p class="font-normal text-center text-sm !p-0 !m-0">
							From lip gelatos to versatile pencils, a 4-in-1 brush, comeback palette designs, and more — this drop is
							all about new ways to enhance your beauty routine. Each piece was made to work seamlessly with your
							staples.
						</p>
						<a
							:href="route"
							aria-label="Shop New Releases link"
							class="text-sm text-white uppercase bg-black !py-3 !px-4 text-center"
						>
							Shop New Releases
						</a>
					</div>
				</template>
				<template v-slot:content-right>
					<figure role="figure" :aria-label="title">
						<img
							:src="reunionModal"
							:alt="title"
							class="w-full object-cover object-top md:object-center max-h-[320px] md:max-h-[460px]"
						/>
					</figure>
				</template>
			</hero-banner-modal>
			<a
				v-else-if="route"
				:href="route"
				class="inline-block text-white cursor-pointer underline text-xs/[18px]"
				:aria-label="cta"
			>
				{{ cta }}
			</a>
		</p>
	</div>
</template>
<script setup>
import { ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'

import { useRewardsStore } from '@stores'

const props = defineProps({
	bannerData: {
		type: Object,
		default: null,
	},
	isCheckout: {
		type: Boolean,
		default: false,
	},
	foundationsEndpoint: {
		type: String,
		required: true,
	},
})

const rewardsStore = useRewardsStore()
const { getRewardById } = storeToRefs(rewardsStore)

const heroModal = ref(null)
const hasModal = ref(props.bannerData?.hasModal ?? false)
const id = ref(props.bannerData?.bannerId) // id that drives rewards config
const message = ref(props.bannerData?.message)
const cta = ref(props.bannerData?.cta_label)
const route = ref(props.bannerData?.cta_route)
const reunionModal = ref('https://s3.us-east-2.amazonaws.com/seint.com/marketing-pages/landing/reunion.jpg')

onMounted(async () => {
	const promises = [reunionModal.value].map((url) => {
		return new Promise((resolve) => {
			const img = new Image()
			img.src = url
			img.onload = resolve
		})
	})

	await Promise.all(promises)
})

const reward = computed(() => getRewardById.value(id.value))
const autoShow = computed(() => {
	if (props.isCheckout) return false
	return props.bannerData?.autoShowModal || props.bannerData?.auto_show_info_modal
})
const title = computed(() => reward.value.modal_attributes.title)
// const description = ref(reward.value.modal_attributes.description) // not in use yet
</script>
